import { Col, Row } from "reactstrap";
import { Fragment } from "react";
import CommonOrganizationStatCard from "./CommonOrganizationStatCard";
import { organizationStatData } from "../../../data/dashboard/ChartData";

const OrganizationStats = () => {
  return (
    <Col xxl="12" lg="12" className="box-col-12 m-0">
      <Row className="gx-2">
        {organizationStatData.map((data, i) => (
          <Fragment key={i}>
            <CommonOrganizationStatCard
              icon={data.icon}
              amount={data.amount}
              title={data.title}
              arrowIcon={data.arrowIcon}
              percentage={data.percentage}
              classExtra={data.classExtra}
             />
          </Fragment>
        ))}
      </Row>
    </Col>
  );
};

export default OrganizationStats;